import api from '../utils/api';

const executiveReportsService = {
  getKpiSummary: () => api.get('/api/executive-reports/kpi-summary'),
  getStaffTurnover: (params = {}) => api.get('/api/executive-reports/staff-turnover', { params }),
  getWorkforceAnalytics: (params = {}) => api.get('/api/executive-reports/workforce-analytics', { params }),
  getAlumniOutcomes: () => api.get('/api/executive-reports/alumni-outcomes'),
  getPdRoi: (params = {}) => api.get('/api/executive-reports/pd-roi', { params }),
  getSurveyInsights: () => api.get('/api/executive-reports/survey-insights'),
  getCohortTrends: () => api.get('/api/executive-reports/cohort-trends'),
  getCapacityForecast: (params = {}) => api.get('/api/executive-reports/capacity-forecast', { params }),
  getAssetUtilization: (params = {}) => api.get('/api/executive-reports/asset-utilization', { params }),
  getPayrollVsBudget: (fiscalPeriodId) => api.get('/api/executive-reports/payroll-vs-budget', { params: { fiscal_period_id: fiscalPeriodId } }),

  // Customizable executive dashboard (widget picker + saved per-user layout)
  getAvailableWidgets: () => api.get('/api/executive-reports/available-widgets'),
  getDashboardLayout: () => api.get('/api/executive-reports/dashboard-layout'),
  saveDashboardLayout: (widgets) => api.put('/api/executive-reports/dashboard-layout', { widgets }),

  // Teacher effectiveness composite score
  getTeacherEffectiveness: (academicTermId, staffId) => api.get('/api/executive-reports/teacher-effectiveness', {
    params: { academic_term_id: academicTermId, staff_id: staffId || undefined },
  }),

  // Exam board benchmarking
  listExamBenchmarks: (params = {}) => api.get('/api/executive-reports/exam-benchmarks', { params }),
  createExamBenchmark: (data) => api.post('/api/executive-reports/exam-benchmarks', data),
  updateExamBenchmark: (id, data) => api.put(`/api/executive-reports/exam-benchmarks/${id}`, data),
  deleteExamBenchmark: (id) => api.delete(`/api/executive-reports/exam-benchmarks/${id}`),
  getExamBenchmarkComparison: (examName, examYear) => api.get('/api/executive-reports/exam-benchmark-comparison', { params: { exam_name: examName, exam_year: examYear } }),

  // Compliance / accreditation register
  listComplianceItems: (params = {}) => api.get('/api/compliance', { params }),
  createComplianceItem: (data) => api.post('/api/compliance', data),
  updateComplianceItem: (id, data) => api.put(`/api/compliance/${id}`, data),
  reviewComplianceItem: (id, data) => api.post(`/api/compliance/${id}/review`, data),
  deleteComplianceItem: (id) => api.delete(`/api/compliance/${id}`),
  getComplianceSummary: () => api.get('/api/compliance/summary'),
};

export default executiveReportsService;
